const state = {
  needcache: false,
  quesData: null,
  translateCount: 0, // 审核国际题库菜单气泡
  tobeTranslateCount: 0, // 审核国际题库菜单气泡
  translateTab: '0',
  // 国际题目搜索下拉条件
  interOptions: [
    { label: '作者', value: 'createUser' },
    { label: '科室', value: 'questionDepart' },
    { label: '关键字', value: 'questionKey' },
    { label: '题目编号', value: 'questionCode' }
  ]
}

const mutations = {
  changeNeedcache (state, v) {
    state.needcache = v;
  },
  changeQuesData: (state, obj) => {
    state.quesData = obj;
  },
  changeTranslateReviewCount: (state, v) => {
    state.translateCount = v;
  },
  changeTobeTranslateCountCount: (state, v) => {
    state.tobeTranslateCount = v;
  },
  changeTranslateTab: (state, v) => {
    state.translateTab = v;
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/enque.js